import { browserHistory } from "react-router";
import RemarksModal from 'template/Modals/Remarks'
import NewPaymentModal, {REFUND, REFUND_CREDIT} from "template/Modals/NewPayment";

import CreateClassOneModal from 'template/Modals/CreateClassOne'
import __R, { userCan } from 'containers/__R'
import locale from './locale'
import {confirm} from 'util/confirm'


// Table setting factory creates table setting object according to 'studentState'

// IMPORTANT NOTE:
// 'this' here is a Tab component such as DefaultTab.
export default function(studentState) {

  if (studentState == "archived") {
    return getArchivedStudentTableSettings.call(this);
  }

  return getDefaultTableSettings.call(this);

}

function getDefaultTableSettings(opts) {
  let TabComponent = this;

  let dropdown = [
    {
      title: __("New Private Class", "student"),
      onClick: ({ trData: student })=>{
        CreateClassOneModal({mode: 'create', studentInfo: [{name: student.sName, id: student.schoolStudentID}]})
      },
      isDisabled: (opts) => {
        return !userCan('create_private_class')
      }
    },
    {
      title: __("Join Class", "student"),
      onClick: ({trData:student})=> {
        this.enrollStudentToClass([student], ()=>{
          let {
            fetchStudent,
            studentState,
          } = this.props.student;

          fetchStudent('after student enrolled @table-setting', studentState)
        });
      },
      isDisabled: (opts) => {
        return !userCan('assign_student_to_class')
      }
    },
    {
      title: __("Remarks", "classdetail"),
      onClick: ({ trData: student })=>{
        RemarksModal({id: student.schoolStudentID, type:'student'})
      },
      isDisabled: (opts) => {
        return !userCan('edit_student_notes')
      }
    },
    {
      title: __("Refund", "student"),
      onClick: ({trData: student}) => {
        let user_id = this.props.user.result.user_id;
        let {fetchStudent, studentState} = this.props.student;

        NewPaymentModal({student, user_id, paymentType: student.classInfo ? REFUND : REFUND_CREDIT })
        .then(() => {
          let {fetchStudent, studentState} = this.props.student;
          fetchStudent('after refund', studentState)
        })
      },
      isDisabled: (opts) => {
        return !userCan('student_refund')
      }
    },
    {
      title: __("Archive Student", locale),
      onClick: ({trData: student}) => {
        let user_id = this.props.user.result.user_id;
        let hasPaid;

        if(student.list && student.list.length >= 1){
          student.list.map((cls) => {
            if(cls.paidTotalFee && cls.paidTotalFee > 0){
              hasPaid = true
            }
          })
        }

        if(hasPaid === true || student.balance > 0){
          confirm(__('This student has paid tuition or credit, do you wish to refund?', locale))
          .then(() => {
            NewPaymentModal({student, user_id, paymentType: REFUND })
            .then(() => {
              this.props.student.archiveSingleStudent('clicking delete @tabble-settings @defaultTab', student);
            })
          })
          .catch(() => {
            this.props.student.archiveSingleStudent('clicking delete @tabble-settings @defaultTab', student);
          })
        } else {
          this.props.student.archiveSingleStudent('clicking delete @tabble-settings @defaultTab', student);
        }
      },
      isDisabled: (opts) => {
        return !userCan('archive_student_from_school')
      }
    },
  ];

	return [
		{
			title: __('Payment', 'finance'),
			onClick: (opts)=>{
        this.payment(opts);
			},
			isDisabled: (opts)=>{
        return !userCan('student_charge')
			}
		},
		{
			title: __('Options', 'teacher'),
			id: "student-dropdown",
			dropdown
		},
	]
}

// Specifically used for archived student table
function getArchivedStudentTableSettings() {
  let TabComponent = this;

	return [
		{
			title: __('Restore', 'teacher'),
			onClick: this.unarchiveStudent,
      isDisabled: (opts) => {
        return !userCan('recover_student_in_school')
      }
		},
	]

}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/table-settings.js